import { useReactFlow, useStore } from '@xyflow/react'
import { Maximize, Minus, Plus } from 'lucide-react'
import { useI18n } from '@/i18n/i18n'

export function ZoomControls() {
  const flow = useReactFlow()
  // Subscribe to zoom only: panning should not re-render the controls.
  const zoom = useStore((st) => st.transform[2])
  const { t } = useI18n()
  const btn =
    'grid h-8 min-w-8 place-items-center rounded-md px-1.5 text-[12px] text-ink-2 transition-colors hover:bg-surface-2 hover:text-ink'
  return (
    <div className="absolute bottom-5 left-4 z-10 flex items-center gap-0.5 rounded-lg border border-line bg-(--chrome) p-1 shadow-md backdrop-blur-xl">
      <button
        type="button"
        className={btn}
        aria-label={t('zoom.out')}
        onClick={() => void flow.zoomOut({ duration: 200 })}
      >
        <Minus size={15} />
      </button>
      <button
        type="button"
        className={`${btn} w-12 tabular-nums`}
        aria-label={t('zoom.reset')}
        onClick={() => void flow.zoomTo(1, { duration: 200 })}
      >
        {Math.round(zoom * 100)}%
      </button>
      <button
        type="button"
        className={btn}
        aria-label={t('zoom.in')}
        onClick={() => void flow.zoomIn({ duration: 200 })}
      >
        <Plus size={15} />
      </button>
      <button
        type="button"
        className={btn}
        aria-label={t('zoom.fit')}
        title={t('zoom.fit')}
        onClick={() => void flow.fitView({ padding: 0.2, duration: 300, maxZoom: 1 })}
      >
        <Maximize size={14} />
      </button>
    </div>
  )
}
